import { atom } from 'jotai';

// User whose rank is explained in the rank dialog (opened from a rank badge or the rank card).
interface RankDialogUser {
  id: string;
  username: string;
  rank?: string;
}

const rankDialogAtom = atom<RankDialogUser | null>(null);

export type { RankDialogUser };

export { rankDialogAtom };
